import { useState } from "react";
import { useDebouncedValue } from "@/hooks/useDebounced";

export const useDebouncedSearch = (initial = "", debounceMs = 400) => {
  const [value, setValue] = useState(initial);
  const debounced = useDebouncedValue(value, debounceMs);
  return {
    value,
    setValue,
    debounced,
  };
};
